module.exports = __webpack_public_path__ + "img/creativity.d14296ed.jpg";